import React from "react";
import { Input, InputGroup, InputRightElement } from "@chakra-ui/react";

export const CustomInput = ({ messageLength, ...props }) => {
  const charactersRemaining = props?.maxLength - (props?.value || "")?.length;
  const isMaxLengthReached = props?.value?.length === props?.maxLength;

  return (
    <InputGroup width={props.width}>
      <Input
        {...props}
        h="42px"
        backgroundColor="#fff"
        autoComplete="off"
        width={props.width}
        border="1px solid #D7D8DE"
        paddingRight={props?.maxLength && messageLength && "55px"}
      />
      {props?.maxLength && messageLength && (
        <InputRightElement
          h="100%"
          display="flex"
          alignItems={props?.height ? "end" : "center"}
          right={"15px"}
        >
          <span
            style={{
              color: isMaxLengthReached ? "red" : "gray",
            }}
          >
            {props?.value?.length}/{charactersRemaining}
          </span>
        </InputRightElement>
      )}
    </InputGroup>
  );
};
